import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { Alert, Spinner } from "@/components/common";

export const ReauthBanner = ({ status }) => {
  const [busy, setBusy] = useState(false);
  if (!status?.needs_reauth) return null;
  const reconnect = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/google-ads/oauth/start");
      try { window.top.location.href = data.auth_url; } catch { window.location.href = data.auth_url; }
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  return (
    <div className="mb-6" data-testid="reauth-banner">
      <Alert tone="amber" title="Google sign-in expired – click Reconnect Google Ads" testid="reauth-alert">
        <p>Google rejected the stored sign-in on {fmtDate(status.needs_reauth.at)} (expired or revoked). Background Google Ads calls are paused until you reconnect. Your selected account and all proposals are kept.</p>
        <p className="mt-1 text-xs opacity-80">To stop this every 7 days: Google Auth Platform → Audience → Publish app (set to In production).</p>
        <button data-testid="reauth-reconnect-button" onClick={reconnect} disabled={busy} className="cc-btn cc-btn-primary mt-3 px-3 py-1.5 text-xs">
          {busy ? <Spinner className="h-3.5 w-3.5" /> : <KeyRound className="h-3.5 w-3.5" />} Reconnect Google Ads
        </button>
      </Alert>
    </div>
  );
};
